import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { authedHttpFetch } from '#pplx/frontend/fetcher/browser.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export function useGetDecagonUserAuth({ enabled = true, } = {}) {
    const isUserLoggedIn = useIsUserLoggedIn();
    return useQuery({
        queryKey: QueryClientHelper.makeQueryKey('/api/decagon/user-auth'),
        queryFn: async () => {
            const response = await authedHttpFetch({
                urlPath: '/api/decagon/user-auth',
                method: 'GET',
                reason: 'decagon-user-auth',
                normalizedPath: '/api/decagon/user-auth',
            });
            if (!response.ok) {
                throw new Error('Failed to fetch Decagon user auth');
            }
            return response.json();
        },
        enabled: BUILD_CAPABILITIES.support && enabled && isUserLoggedIn,
    });
}
//# sourceMappingURL=useGetDecagonUserAuth.js.map